import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Badge, Tab, Tabs, Button, Form, Spinner } from 'react-bootstrap';
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";

import { placeBid, instantBuy, cancelBid, acceptBid, cancelAuction } from "../components/contract functions/AuctionCall";
import { getAuctionDetails, getAllBids, getBidDetails, convertNormaltoTokenAmount, convertTokentoNormalAmount } from '../components/blockchain functions/BlockchainFunctions';
import GetNFT from '../components/page-components/getNFT';
import { chains, eyeglasses, hats, leftHands, rightHands, getGeneration } from '../components/page-components/metadata';
import { validGameNFT } from "../components/page-components/Random";
import { LoginContext } from "../context/LoginContext";
//Icon
import openIcon from '../components/assets/icons/open-square.svg';
import closeIcon from '../components/assets/icons/close-square.svg';

const ViewNFTInAuction = () => {
    const { id } = useParams();
    const history = useHistory()

    const [loading, setLoading] = useState(false);//Loading bar

    const [nftData, setNFTData] = useState({});
    const [bidList, setBidList] = useState([]);
    const [canBreed, setCanBreed] = useState("No");
    const [bidForm, setBidForm] = useState(false);
    const [loginData, setLoginData] = useContext(LoginContext);

    const [chain, setChain] = useState("-");
    const [eyeglass, setEyeglass] = useState("-");
    const [hat, setHat] = useState("-");
    const [lefthand, setLefthand] = useState("-");
    const [righthand, setRighthand] = useState("-");
    const [bgColor, setBgColor] = useState("");

    useEffect(async () => {
        setLoading(true);
        let NFTData = await getAuctionDetails(id);
        console.log(NFTData);
        setNFTData(NFTData);
        //get all bids
        let BidList = await getAllBids(id);
        let BidDataList = [];
        console.log(BidList);
        for (let i = 0; i < BidList.length; i++) {
            let bidId = BidList[i];
            BidDataList.push(await getBidDetails(id, bidId));
        }
        setBidList(BidDataList);
        console.log(BidDataList);
        setLoading(false);
    }, []);

    const getAttribute = (name) => {
        var hatId = parseInt(name.slice(6, 7));
        var eyeglassId = parseInt(name.slice(7, 8));
        var chainId = parseInt(name.slice(8, 9));
        var lefthandId = parseInt(name.slice(9, 11));
        var righthandId = parseInt(name.slice(11, 13));

        //Set Images
        if (chains[chainId] !== undefined)
            setChain(chains[chainId]);
        if (eyeglasses[eyeglassId] !== undefined)
            setEyeglass(eyeglasses[eyeglassId]);
        if (hats[hatId] !== undefined)
            setHat(hats[hatId]);
        if (leftHands[lefthandId] !== undefined)
            setLefthand(leftHands[lefthandId]);
        if (rightHands[righthandId] !== undefined)
            setRighthand(rightHands[righthandId]);


        //Background Color
        var bg = name.charAt(name.length - 1);
        switch (bg) {
            case 'R': setBgColor("Red");
                break;
            case 'G': setBgColor("Green");
                break;
            case 'B': setBgColor("Blue");
                break;
            case 'Y': setBgColor("Yellow");
                break;
            default: setBgColor("-");
        }
    }

    useEffect(async () => {
        // console.log(nftData);
        if (nftData?.assetData!=undefined && JSON.parse(nftData?.assetData?.description?.toString()).crossbreeding)
            setCanBreed("Yes");
        if(nftData?.assetData!=undefined)
            getAttribute(nftData?.assetData?.name);
    }, [nftData]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        var bidAmount = convertNormaltoTokenAmount(event.target.bidAmount.value);
        // console.log(id, bidAmount);
        let result;
        if(bidAmount==nftData?.auctionInstantPrice){
            result = await instantBuy(id, bidAmount, loginData.phrase);
        } else
            result = await placeBid(id, bidAmount, loginData.phrase);
        if(result){
            setBidForm(false);
            toast.success("Bid placed successfully");
            window.setInterval(function () {window.location.reload()},4000);
        }
        setLoading(false);
    };

    const cancelThisBid = async (bidId) => {
        setLoading(true);
        let result = await cancelBid(id, bidId, loginData.phrase);
        if(result){
            toast.success("Bid canceled successfully");
            window.setInterval(function () {window.location.reload()},4000);
        }
        setLoading(false);
    }

    const acceptHighestBid = async () => {
        setLoading(true);
        //Find highest bid data
        var highestBidId = bidList[0].bidId;
        var highestBidAmount = bidList[0].amount;
        for (let i = 1; i < bidList.length; i++) {
            if (highestBidAmount < bidList[i].amount) {
                highestBidId = bidList[i].bidId;
                highestBidAmount = bidList[i].amount;
            }
        }
        //auctionId, bidId, bidAmount, bidderSeed
        let result = await acceptBid(id, highestBidId, highestBidAmount, loginData.phrase);
        console.log(result);
        if(result){
            toast.success("Highest bid accept successfully");
            window.setInterval(function () {window.location.reload()},4000);
        }
        setLoading(false);
    }

    const cancelThisAuction = async () => {
        setLoading(true);
        let result = await cancelAuction(id, loginData.phrase);
        if(result){
            toast.success("Auction canceled successfully");
            window.setInterval(function () {window.location.reload()},4000);
        }
        setLoading(false);
    }


    return (
        <>
            <div className={loading ? 'parentDisable' : ''} width="100%">
                <br />
                <div className={loading ? 'overlay-box' : 'hide'}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
                <div className="full-screen">
                    <Row>
                        <Col sm={6}>
                            <div className="nftData">
                                <GetNFT nftName={nftData?.assetData?.name} />
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className="nftData">
                                <div className="details">
                                    <span className="name">{nftData?.assetData?.name}</span><span className="issueHeight">#{nftData?.assetData?.issueHeight}</span><br />
                                    <span className="assetId">{nftData?.assetData?.assetId}</span><br />
                                    <hr />
                                    <div hidden={bidForm}>
                                        <Tabs defaultActiveKey="auctionDetails" id="uncontrolled-tab-example" className="mb-3">
                                            <Tab eventKey="auctionDetails" title="Auction Details">
                                                <br />
                                                <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#6c757d", color: "white" }}>
                                                    Details
                                                </div>
                                                <br />
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">AuctionId</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> {nftData?.auctionId}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Auction Description</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> {nftData?.auctionDescription==""?"-":nftData?.auctionDescription}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Initial price</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> {nftData.auctionStartPrice?convertTokentoNormalAmount(nftData.auctionStartPrice).substr(0,4):""}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Buyout Price</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> {nftData.auctionInstantPrice?convertTokentoNormalAmount(nftData.auctionInstantPrice).substr(0,4):""}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">OwnerId</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> {nftData?.auctionOwner}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Auction Start Date</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {new Date(nftData?.auctionStartedAt).toLocaleString()}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Status</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> <img style={{height:"4rem",paddingLeft:"20px"}} src={nftData?.status == "open" ? openIcon : closeIcon} />
                                                    </span>
                                                </div>
                                                <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#6c757d", color: "white" }}>
                                                    Bids ({nftData?.totalBids})
                                                </div>
                                                <br />
                                                {bidList.map((data, key) => {
                                                    return (
                                                        <div className="view-nft-details" key={key}>
                                                            <span className="fw-bold text-start">{data.author.substr(0, 6) + "......" + data.author.substr(-5, 5)}</span>
                                                            <span className="dot"></span>
                                                            <span className="text-end text-capitalize"> {convertTokentoNormalAmount(data.amount).substr(0,4)}</span>
                                                            {data.author == loginData.walletAddress ?
                                                                <>
                                                                    <span className="dot"></span>
                                                                    <Button variant="danger" onClick={() => cancelThisBid(data.bidId)}>Cancel Bid</Button>
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                        </div>
                                                    );
                                                })}
                                            </Tab>
                                            <Tab eventKey="NFTDetails" title="NFTDetails">
                                                <br />
                                                <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#6c757d", color: "white" }}>
                                                    Details
                                                </div>
                                                <br />
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Birth DateTime</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> {(new Date(nftData?.assetData?.issueTimestamp)).toLocaleString()}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Production Rate</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> 0.25</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Can Breed</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> <Badge bg="danger">{canBreed}</Badge></span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Status</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end"> <Badge bg="success">Active</Badge></span>
                                                </div>
                                                <br />
                                                <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#6c757d", color: "white" }}>
                                                    Attributes
                                                </div>
                                                <br />
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Chain</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {chain}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Eyeglass</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {eyeglass}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Hat</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {hat}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Lefthand</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {lefthand}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Righthand</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {righthand}</span>
                                                </div>
                                                <div className="view-nft-details">
                                                    <span className="fw-bold text-start">Backgroundcolor</span>
                                                    <span className="dot"></span>
                                                    <span className="text-end text-capitalize"> {bgColor}</span>
                                                </div>
                                            </Tab>
                                        </Tabs>
                                        <Row>
                                            {nftData.status == "open" ?
                                                nftData?.auctionOwner == loginData?.walletAddress ?
                                                    <Button variant="primary" size="lg" style={{ marginTop: "20px" }}
                                                        onClick={() => bidList.length > 0 ? acceptHighestBid() : cancelThisAuction()}>{bidList.length > 0 ? "Accept Highest Bid" : "Cancel Auction"}</Button>
                                                    :
                                                    <Button variant="primary" size="lg" style={{ marginTop: "20px" }}
                                                        onClick={() => setBidForm(true)}>Bid</Button>
                                                :
                                                <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#dc3545", color: "white" }}>
                                                    Auction is completed.
                                                </div>
                                            }
                                        </Row>
                                    </div>
                                    <div hidden={!bidForm}>
                                        <Form onSubmit={handleSubmit}>
                                            <Form.Group>
                                                <Form.Label>Select Bid Amount</Form.Label>
                                                <Form.Control type="number" min={convertTokentoNormalAmount(nftData?.auctionStartPrice).substr(0,4)} step="0.05" defaultValue={convertTokentoNormalAmount(nftData?.auctionStartPrice).substr(0,4)} max={nftData?.auctionInstantPrice} id="bidAmount" required />
                                            </Form.Group>
                                            <br />
                                            <Row>
                                                <div style={{ width: '50%' }} >
                                                    <Button variant="secondary" size="lg" style={{ width: '100%' }} onClick={() => setBidForm(false)}>Cancel</Button>
                                                </div>
                                                <div style={{ width: '50%' }} >
                                                    <Button variant="primary" type="submit" size="lg" style={{ width: '100%' }}>Start</Button>
                                                </div>
                                            </Row>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default ViewNFTInAuction;